import Transaction from './Transaction';

export default class EarlyBirdEnrollment {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {number}
   */
  clientId;

  /**
   * @type {number}
   */
  typeId = 1;

  /**
   * @type {number}
   */
  transactionId;

  /**
   * @type {string}
   */
  dateAdded;

  /**
   * @type {Transaction}
   */
  transaction;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.clientId != null) {
        this.clientId = opts.clientId;
      }
      if (opts.typeId != null) {
        this.typeId = opts.typeId;
      }
      if (opts.transactionId != null) {
        this.transactionId = opts.transactionId;
      }
      if (opts.dateAdded != null) {
        this.dateAdded = opts.dateAdded;
      }
      if (opts.transaction != null) {
        this.transaction = new Transaction(opts.transaction);
      }
    }
  }
}
